import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import NativeDropdown from '@xanadu/ui-shared/components/widgets/NativeDropdown';
import { MOBILE_BREAKPOINT } from '../../../constants';
import Input from '../../widgets/Input';

import CloseIcon from '../../../../images/icons/misc/close.svg';

import styles from './Filters.module.scss';

const SORT_ODDS_OPTION = { id: 'odds', name: 'Odds', value: 'odds' };
const SORT_NAME_OPTION = { id: 'name', name: 'Name', value: 'name' };

const SORT_RUNNERS_OPTIONS = {
  'horse-racing': [
    { ...SORT_ODDS_OPTION },
    { ...SORT_NAME_OPTION },
    { id: 'number', name: 'Number', value: 'number' }
  ],
  'greyhound-racing': [],
};

const PLACEHOLDERS_BY_SPORT = {
  'horse-racing': window.innerWidth <= MOBILE_BREAKPOINT ? 'Runner, Trainer ...' : 'Runner Name',
  'greyhound-racing': 'Runner Name',
};

const clearButtonClass = classNames({
  hint: true,
  'hint--top': true,
  [styles.clearFilter]: true,
});

const Filters = ({
  sportUrlName,
  filterValue,
  sortType,
  onSortChange,
  onFilterChange,
  onClearFilter,
}) => (
  <div className={styles.main}>
    <div className={styles.filter}>
      <label htmlFor="runner-name-filter">Filter by</label>
      <Input
        name="runner-name-filter"
        layout="outlined"
        placeholder={PLACEHOLDERS_BY_SPORT[sportUrlName] || 'Runner Name'}
        onChange={onFilterChange}
        value={filterValue}
      />
      {!!filterValue && (
        <span
          className={clearButtonClass}
          onClick={onClearFilter}
          role="button"
          aria-label={'Clear filter'}
          tabIndex={0}
        >
          <CloseIcon />
        </span>
      )}
    </div>
    {sportUrlName !== 'greyhound-racing' && (
      <div className={styles.filter}>
        <label htmlFor="runner-sort-type">Sort by</label>
        <NativeDropdown
          name="runner-sort-type"
          options={SORT_RUNNERS_OPTIONS[sportUrlName] || [SORT_ODDS_OPTION, SORT_NAME_OPTION]}
          onChange={onSortChange}
          value={sortType}
          theme="dark-high-contrast"
        />
      </div>
    )}
  </div>
);

Filters.propTypes = {
  sportUrlName: PropTypes.string.isRequired,
  filterValue: PropTypes.string.isRequired,
  sortType: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onClearFilter: PropTypes.func.isRequired,
};

export default Filters;
